export enum ReconcilePaymentsAgainstInvoiceOptions {
   MANDATORY = 'mandatory',
   OPTIONAL = 'optional',
   NEVER = 'never'
}